var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"number-counter"},[_c('div',[_c('span',{staticClass:"number"},[_vm._v(_vm._s(_vm.animatedNumber.toFixed(0)))]),_c('span',{staticClass:"dec"},[_vm._v(_vm._s(_vm.dec))]),_c('span')]),_c('br'),_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }